import isString from 'lodash/isString'

export function replaceAll(str, search, replacement) {
  let newStr = '';
  if (isString(str)) {
    newStr = str.split(search).join(replacement);
  }
  return newStr;
}